import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ViewScope } from './view-scope';
import { buildViewScopeKey } from './view-scope';

export type ViewFilters = unknown;

interface ViewFiltersState {
  filtersByKey: Record<string, ViewFilters>;
}

const initialState: ViewFiltersState = {
  filtersByKey: {},
};

const viewFiltersSlice = createSlice({
  name: 'viewFilters',
  initialState,
  reducers: {
    setFiltersForScope(state, action: PayloadAction<{ scope: ViewScope; filters: ViewFilters }>) {
      const { scope, filters } = action.payload;
      const key = buildViewScopeKey(scope);
      state.filtersByKey[key] = filters;
    },
    updateFiltersForScope(
      state,
      action: PayloadAction<{ scope: ViewScope; partialFilters: Record<string, unknown> }>,
    ) {
      const { scope, partialFilters } = action.payload;
      const key = buildViewScopeKey(scope);

      const prev = (state.filtersByKey[key] as Record<string, unknown> | undefined) ?? {};

      state.filtersByKey[key] = { ...prev, ...partialFilters };
    },
    resetFiltersForScope(state, action: PayloadAction<{ scope: ViewScope }>) {
      const { scope } = action.payload;
      const key = buildViewScopeKey(scope);
      delete state.filtersByKey[key];
    },
  },
});

export const { reducer: viewFiltersReducer, actions: viewFiltersActions } = viewFiltersSlice;
